import { selector } from 'selectors/request';
import { useSelector } from 'react-redux';
import useFSPConfigID from '../useFSPConfigID';

const useFSPConfigRequestState = (action, customId) => {
  const { id } = useFSPConfigID();

  return useSelector((s) => selector(s, action, customId ?? id));
};

export default useFSPConfigRequestState;
